"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = QuestInventoryWindow;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _QuestInventoryWindowModule = _interopRequireDefault(require("./QuestInventoryWindow.module.scss"));

var _ItemPool = _interopRequireDefault(require("../../../entities/ItemPool/ItemPool"));

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function QuestInventoryWindow(_ref) {
  var itemPool = _ref.itemPool,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  if (itemPool && (itemPool.sizeX !== 7 || itemPool.sizeY !== 6)) {
    throw new Error("itemPool with invalid size '".concat(itemPool.sizeX, "x").concat(itemPool.sizeY, "' was passed to LootWindow."));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_QuestInventoryWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameDragHandler: _QuestInventoryWindowModule.default.dragHandler,
    classNameCloseBtn: _QuestInventoryWindowModule.default.closeBtn
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestInventoryWindowModule.default.itemPoolWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestInventoryWindowModule.default.itemPool
  }, /*#__PURE__*/_react.default.createElement(_ItemPool.default, {
    sizeX: 7,
    sizeY: 6,
    itemPool: itemPool,
    isTiled: true
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestInventoryWindowModule.default.categoryList
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _QuestInventoryWindowModule.default.trashBin
  }));
}